// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 发送验证码 POST /api/login/captcha */
export async function getFakeCaptcha(
  params: {
    // query
    /** 手机号 */
    phone?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.FakeCaptcha>('/api/login/captcha', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取RSA公钥 GET /app/auth/v1/publicKey */
export async function getRSAPublicKey(
  options?: { [key: string]: any },
) {
  return request<{
    requestId: string;
    code: string;
    message: string;
    success: boolean;
    data: {
      publicKey: string;
    };
  }>('/app/auth/v1/publicKey', {
    method: 'GET',
    ...(options || {}),
  });
}
